const CptName = 'ComImgDesc'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      value: node.innerText
    },
    cpt: CptName
  }
}

export default {
  name: 'img_desc',
  formatData
}
